import { useMutation } from "react-query";
import api from "../../client";
import {
  RepresentativeDetailResponseData,
  UpdateRepresentativePayload,
} from "../../types/representative";

const patchData = async (
  id: string | undefined,
  payload: UpdateRepresentativePayload,
): Promise<RepresentativeDetailResponseData> => {
  const { data } = await api.patch(`/representatives/${id}`, payload);

  return data;
};

export const useUpdateRepresentative = (id: string | undefined) => {
  return useMutation((payload: UpdateRepresentativePayload) => {
    return patchData(id, payload);
  });
};
